module.exports = __webpack_public_path__ + "img/shape-metal_az_mobile_hover@2x.2fc5a438.png";